
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "commitHash": "02ebaa8ef1920e8b6a81f0d0978f28cff0a2d256",
    "version": "12.0.3"
};
